(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["v6-home-5"] && !Shopify.designMode) return;
  try {
    
if (!window.lorvyoInlineVideo82) {
  window.lorvyoInlineVideo82 = true;
  const selector = '.lv82-inline-video';
  function pauseOthers(current) {
    document.querySelectorAll(selector).forEach(function(video) {
      if (video !== current) video.pause();
    });
  }
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) { if (!entry.isIntersecting) entry.target.pause(); });
  }, { threshold: 0 }) : null;
  document.addEventListener('click', function(event) {
    const trigger = event.target.closest('[data-lv82-video]');
    if (!trigger) return;
    const card = trigger.closest('.lv82-video-card');
    if (!card) return;
    let video = card.querySelector(selector);
    if (!video) {
      video = document.createElement('video');
      video.className = 'lv82-inline-video';
      video.controls = true;
      video.playsInline = true;
      video.preload = 'none';
      video.tabIndex = 0;
      video.setAttribute('aria-label', trigger.dataset.clipTitle || 'Product video');
      video.dataset.stopAt = trigger.dataset.stopAt;
      const poster = trigger.querySelector('img');
      if (poster) video.poster = poster.currentSrc || poster.src;
      trigger.before(video);
      video.addEventListener('error', function() {
        video.pause();
        if (observer) observer.unobserve(video);
        video.remove();
        trigger.style.display = '';
        trigger.focus({ preventScroll: true });
      }, { once: true });
      if (observer) observer.observe(video);
    }
    trigger.style.display = 'none';
    pauseOthers(video);
    if (!video.hasAttribute('src')) video.src = trigger.dataset.lv82Video;
    video.focus({ preventScroll: true });
    video.play().catch(function() {});
  });
  document.addEventListener('play', function(event) {
    if (event.target.matches(selector)) pauseOthers(event.target);
  }, true);
  document.addEventListener('timeupdate', function(event) {
    if (!event.target.matches(selector)) return;
    const stop = Number(event.target.dataset.stopAt);
    if (stop > 0 && event.target.currentTime >= stop) {
      event.target.pause();
      event.target.currentTime = 0;
    }
  }, true);
  document.addEventListener('visibilitychange', function() {
    if (document.hidden) pauseOthers(null);
  });
  document.addEventListener('shopify:section:unload', function(event) {
    event.target.querySelectorAll(selector).forEach(function(video) {
      video.pause();
      if (observer) observer.unobserve(video);
      video.removeAttribute('src');
      video.load();
    });
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["v6-overlays"] && !Shopify.designMode) return;
  try {
    
function revealWelcomeResult(){const result=document.querySelector('[data-lv82-form-result]');if(result){const dialog=result.closest('dialog');if(dialog&&!dialog.open)dialog.showModal();}}document.addEventListener('DOMContentLoaded',revealWelcomeResult);document.addEventListener('shopify:section:load',revealWelcomeResult);
(() => {
  if (window.lorvyoPurchaseControls) return;
  window.lorvyoPurchaseControls = true;
  let serial = 0;
  function initialize(root = document) {
    root.querySelectorAll('.lv-product-form').forEach(form => {
      if (form.dataset.quantityReady) return;
      const input = form.querySelector('[name="quantity"]');
      const anchor = form.querySelector('.lv-catalog-purchase-row') || form.querySelector('button[type="submit"]');
      if (!input || !anchor) return;
      form.dataset.quantityReady = 'true';
      form.classList.add('lv84-purchase');
      const scope = form.closest('[data-product-section]') || form;
      const labelText = document.querySelector('[data-lv84-labels]')?.dataset.quantity || 'Quantity';
      const oldParent = input.parentElement;
      input.type = 'number'; input.hidden = false; input.required = true;
      input.min = input.min || '1'; input.max = input.max || '99'; input.step = input.step || '1';
      input.inputMode = 'numeric'; input.id = input.id || 'lv84-quantity-' + (++serial);
      const widgets = [];
      function widget(field) {
        const group = document.createElement('div'); group.className = 'lv84-quantity';
        const label = document.createElement('label'); label.htmlFor = field.id; label.textContent = labelText;
        const stepper = document.createElement('div'); stepper.className = 'lv84-stepper';
        const minus = document.createElement('button'), plus = document.createElement('button');
        minus.type = plus.type = 'button'; minus.textContent = '−'; plus.textContent = '+';
        minus.setAttribute('aria-label', labelText + ' −'); plus.setAttribute('aria-label', labelText + ' +');
        minus.dataset.quantityStep = '-1'; plus.dataset.quantityStep = '1';
        stepper.append(minus, field, plus); group.append(label, stepper); widgets.push({field, minus, plus});
        field.addEventListener('input', () => synchronize(field.value));
        field.addEventListener('change', () => synchronize(field.value));
        [minus, plus].forEach(button => button.addEventListener('click', () => {
          if (form.dataset.pending === 'true') return;
          const min = Number(input.min), max = Number(input.max), step = Number(input.step);
          const value = Number.isFinite(input.valueAsNumber) ? input.valueAsNumber : min;
          synchronize(String(Math.max(min, Math.min(max, value + Number(button.dataset.quantityStep) * step))));
          input.dispatchEvent(new Event('change', {bubbles:true}));
        }));
        return group;
      }
      const mainWidget = widget(input); anchor.before(mainWidget);
      if (oldParent !== form && (oldParent.matches('.lv-catalog-quantity') || oldParent.tagName === 'LABEL')) oldParent.remove();
      const sticky = scope.querySelector('[data-v7-sticky]');
      if (sticky) {
        sticky.classList.add('lv84-sticky');
        const order = form.querySelector('[data-order-now]');
        if (order && !sticky.querySelector('[data-order-now]')) {
          const clone = order.cloneNode(true); clone.removeAttribute('id'); clone.setAttribute('form', form.getAttribute('id'));
          clone.classList.add('lv84-sticky-order'); sticky.append(clone);
        }
      }
      function synchronize(value = input.value) {
        const pending = form.dataset.pending === 'true';
        widgets.forEach(({field, minus, plus}) => {
          field.value = value; field.readOnly = pending;
          minus.disabled = pending || Number(value) <= Number(input.min);
          plus.disabled = pending || Number(value) >= Number(input.max);
        });
      }
      new MutationObserver(() => synchronize()).observe(form, {attributes:true,attributeFilter:['data-pending']});
      synchronize();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
  else initialize();
  document.addEventListener('shopify:section:load', () => initialize());
})();


  } catch(e) { console.error(e); }
})();
})();
